import { AnalyticsProvider, createClient, i18n, AuthProvider, captureObservabilityError } from '@psyomics/ui-common';
import { GenericError } from '@psyomics/ui-components';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Provider as UrqlProvider } from 'urql';

import { AuthRoutes } from './auth-routes';
import { getConfig } from './config';

export const renderRoot = () => {
  const htmlElement = document.getElementById('root');

  if (!htmlElement) {
    throw Error('no root dom element');
  }

  const root = ReactDOM.createRoot(htmlElement);
  const config = getConfig();
  const { clinicianApiUrl, clinicianApiCognitoDomain, postHogApiKey, postHogHost } = config;

  root.render(
    <StrictMode>
      <AnalyticsProvider apiKey={postHogApiKey} host={postHogHost}>
        <BrowserRouter>
          <ErrorBoundary fallback={<GenericError />} onError={captureObservabilityError}>
            <I18nextProvider i18n={i18n}>
              <AuthProvider apiUrl={clinicianApiUrl} cognitoDomain={clinicianApiCognitoDomain}>
                <UrqlProvider value={createClient(`${clinicianApiUrl}/graphql`)}>
                  <AuthRoutes />
                </UrqlProvider>
              </AuthProvider>
            </I18nextProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </AnalyticsProvider>
    </StrictMode>
  );
};
